'use client'

import React from 'react'
import { useModals } from '@/lib/hooks'

import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui'
import { PaymentCardVerification } from '@/components/forms/payment-card-verification'

interface PaymentCardVerificationModalProps
  extends React.ComponentPropsWithoutRef<'div'> {
  open?: boolean
}

export const PaymentCardVerificationModal = ({
  open,
}: PaymentCardVerificationModalProps) => {
  const { closeModal, closeAll } = useModals()

  return (
    <Dialog open={open}>
      <DialogContent
        closeOnOverlay
        onClose={() => closeModal('PAYMENT_CARD_VERIFICATION')}
        size="lg"
      >
        <DialogHeader>
          <DialogTitle>Payment Card Verification</DialogTitle>
          <DialogDescription>
            Enter the customer&apos;s card details
          </DialogDescription>
        </DialogHeader>

        <PaymentCardVerification onClose={() => closeAll()} />
      </DialogContent>
    </Dialog>
  )
}
